const isEntityAvailable = (data, entity) => {
  return data[entity] && data[entity].edges && data[entity].edges.length;
};

export default isEntityAvailable;
